import Vue from "vue";
import VueRouter from "vue-router";

import Header from "../components/Header";
import Home from "../components/Home";
import BaseSet from "../components/system/sysbaseset";
import SysUser from "../components/system/sysuser";
import SysDept from "../components/system/sysdept";
import Login from "../components/Login";
import DeptAndUser from "../components/system/deptAndUser";
import MyApplyRecord from "../components/apply/MyApplyRecord";
import MyApplyList from "../components/apply/MyApplyList";
import MyApplyWait from "../components/apply/MyApplyWait";
import MyOutRecords from "@/components/apply/MyOutRecords";
import UserCenter from "../components/system/userCenter";
import SiteLetter from "../components/system/siteLetter";
import SysLog from "../components/system/sysLog";
import TestCount from "../components/TestCount";
import Browser from "../components/browser";
import ContractApply from "../components/item/contract/ContractApply";
import ProjectApply from "../components/item/project/ProjectApply";
import CostReportApply from "../components/item/costreport/CostReportApply";
import PaymentApply from "../components/item/payment/PaymentApply";
import OutReportApply from "@/components/item/outreport/OutReportApply";
import LeaveApply from "@/components/item/leave/LeaveApply";
import Dealt from "../components/system/dealt";
import DealtAll from "../components/system/dealt/all";
import Flow from "../components/flow/flow";
import FlowLine from "../components/flow/line";
import ReimburseApply from "../components/item/reimburse/ReimburseApply";
import SealApply from "../components/item/seal/SealApply";
import EnforceApply from "../components/item/enforce/EnforceApply";
import ContractDetail from "../components/item/contract/ContractDetail";
import CostReportDetail from "../components/item/costreport/CostReportDetail";
import EnforceDetail from "../components/item/enforce/EnforceDetail";
import LeaveDetail from "../components/item/leave/LeaveDetail";
import OutReportDetail from "../components/item/outreport/OutReportDetail";
import PaymentDetail from "../components/item/payment/PaymentDetail";
import ProjectDetail from "../components/item/project/ProjectDetail";
import ReimburseDetail from "../components/item/reimburse/ReimburseDetail";
import SealDetail from "../components/item/seal/SealDetail";
import CoworkingDetail from "@/components/item/coworking/CoworkingDetail.vue";
import CoworkingApply from "@/components/item/coworking/CoworkingApply.vue";
import ProjectModify from "@/components/item/project/ProjectModifyApply.vue";
import ProjectModifyDetail from "@/components/item/project/ProjectModifyDetail.vue";
import AllApply from "../components/system/apply/AllApply";
import AllReimburse from "../components/system/reimburse/AllReimburse";
import loginSuccess from "../h5/login/success";
import loginFail from "../h5/login/fail";
import bandingSuccess from "../h5/banding/success";
import bandingFail from "../h5/banding/fail";
import allOut from "../components/item/outreport/all";
import allProject from "../components/item/project/all";
import allLeave from "../components/item/leave/all";
import EnforceFile from "@/components/item/enforce/EnforceFile";
import Purchase from "@/components/item/purchase/PurchaseApply";
import PurchaseDetail from "@/components/item/purchase/PurchaseDetail";
import Allege from "@/components/item/allege/AllegeApply";
import AllegeDetail from "@/components/item/allege/AllegeDetail";
import Export from "@/components/system/export/index";
import AllContract from "@/components/item/contract/all";
import Invoice from "@/components/item/invoice/InvoiceApply.vue"
import InvoiceDetail from "@/components/item/invoice/InvoiceDetail.vue"
import Delivery from "../components/item/delivery/DeliveryApply.vue";
import DeliveryDetail from "../components/item/delivery/DeliveryDetail.vue";
import AllPayment from "../components/item/payment/all.vue";
import AllDelivery from "../components/item/delivery/all.vue";
import AllPettyCash from "../components/item/pettyCash/all.vue";
import PettyCash from "../components/item/pettyCash/PettyCashApply.vue";
import PettyCashDetail from "../components/item/pettyCash/PettyCashDetail.vue";



Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Header",
    component: Header,
    redirect: Home,
    alias: "/index",
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
      },

      {
        path: "/flow/flow",
        name: "flow",
        component: Flow,
      },
      {
        path: "/flow/line",
        name: "baseSet",
        component: FlowLine,
      },
      {
        path: "/system/baseSet",
        name: "baseSet",
        component: BaseSet,
      },
      {
        path: "/system/dealt",
        name: "dealt",
        component: Dealt,
      },
      {
        path: "/system/dealt/all",
        name: "dealtAll",
        component: DealtAll,
      },
      {
        path: "/system/sysUser",
        name: "sysUser",
        component: SysUser,
      },
      {
        path: "/system/sysDept",
        name: "sysDept",
        component: SysDept,
      },
      {
        path: "/system/deptAndUser",
        name: "deptAndUser",
        component: DeptAndUser,
      },

      {
        path: "/user/center",
        name: "userCenter",
        component: UserCenter,
      },
      {
        path: "/sys/siteLetter",
        name: "siteLetter",
        component: SiteLetter,
      },
      {
        path: "/system/sysLog",
        name: "SysLog",
        component: SysLog,
      },
      {
        path: "/system/export",
        name: "Export",
        component: Export,
      },

      {
        path: "/browser",
        name: "Browser",
        component: Browser,
      },
      {
        path: "/testCount",
        name: "TestCount",
        component: TestCount,
      },
      {
        //  我的申请待审核
        path: "/my/apply/wait",
        name: "MyApplyWait",
        component: MyApplyWait,
      },
      {
        //  我的申请列表
        path: "/my/apply/list",
        name: "MyApplyList",
        component: MyApplyList,
      },
      {
        //  我的审批记录
        path: "/my/apply/record",
        name: "MyApplyRecord",
        component: MyApplyRecord,
      },
      {
        //  我的外出记录
        path: "/my/outReport/record",
        name: "MyOutRecords",
        component: MyOutRecords,
      },
      {
        //  立项申请
        path: "/item/project",
        name: "ProjectApply",
        component: ProjectApply,
      },
      {
        //  招待费报备
        path: "/item/costreport",
        name: "CostReport",
        component: CostReportApply,
      },
      {
        //  费用报销申请
        path: "/item/reimburse",
        name: "Reimburse",
        component: ReimburseApply,
      },
      {
        //  外出申请
        path: "/item/outreport",
        name: "OutReport",
        component: OutReportApply,
      },
      {
        //  所有外出
        path: "/out/all",
        name: "allOut",
        component: allOut,
      },
      {
        //  请假申请
        path: "/item/leave",
        name: "Leave",
        component: LeaveApply,
      },
      {
        //  协同办公申请
        path: "/item/coworking",
        name: "Coworking",
        component: CoworkingApply,
      },
      {
        //  所有请假
        path: "/leave/all",
        name: "allLeave",
        component: allLeave,
      },
      {
        //  档案管理
        path: "/item/enforce",
        name: "EnforceApply",
        component: EnforceApply,
      },
      {
        //  实施文档
        path: "/system/enforceFile",
        name: "EnforceFile",
        component: EnforceFile,
      },
      {
        //  付款申请单
        path: "/item/payment",
        name: "Payment",
        component: PaymentApply,
      },
      {
        //  用章申请
        path: "/item/seal",
        name: "Seal",
        component: SealApply,
      },
      {
        //  合同申请
        path: "/item/contract",
        name: "Contract",
        component: ContractApply,
      },
      {
        //  项目变更申请
        path: "/item/projectModify",
        name: "ProjectModify",
        component: ProjectModify,
      },
      {
        //  项目变更申请详情
        path: "/item/projectModify/detail",
        name: "ProjectModifyDetail",
        component: ProjectModifyDetail,
      },
      {
        //  采购申请
        path: "/item/purchase",
        name: "Purchase",
        component: Purchase,
      },
      {
        //  采购申请详情
        path: "/item/purchase/detail",
        name: "PurchaseDetail",
        component: PurchaseDetail,
      },
      {
        //  考勤申述申请
        path: "/item/allege",
        name: "Allege",
        component: Allege,
      },
      {
        //  考勤申述详情
        path: "/item/allege/detail",
        name: "AllegeDetail",
        component: AllegeDetail,
      },
      {
        path: "/item/invoice",
        name: "Invoice",
        component: Invoice,
      },
      {
        path: "/item/invoice/detail",
        name: "InvoiceDetail",
        component: InvoiceDetail,
      },
      {
        path: "/item/delivery",
        name: "Delivery",
        component: Delivery,
      },
      {
        path: "/item/delivery/detail",
        name: "DeliveryDetail",
        component: DeliveryDetail,
      },
      {
        //  合同详情
        path: "/item/contract/detail",
        name: "ContractDetail",
        component: ContractDetail,
      },
      {
        //  招待费报备
        path: "/item/costreport/detail",
        name: "CostReportDetail",
        component: CostReportDetail,
      },
      {
        //  实施文件归档详情
        path: "/item/enforce/detail",
        name: "EnforceDetail",
        component: EnforceDetail,
      },
      {
        //  请假详情
        path: "/item/leave/detail",
        name: "LeaveDetail",
        component: LeaveDetail,
      },
      {
        //  外出申请详情
        path: "/item/outreport/detail",
        name: "OutReportDetail",
        component: OutReportDetail,
      },
      {
        //  付款申请详情
        path: "/item/payment/detail",
        name: "PaymentDetail",
        component: PaymentDetail,
      },
      {
        //  立项详情
        path: "/item/project/detail",
        name: "ProjectDetail",
        component: ProjectDetail,
      },
      {
        //  协同办公详情
        path: "/item/coworking/detail",
        name: "CoworkingDetail",
        component: CoworkingDetail,
      },
      {
        //  报销详情
        path: "/item/reimburse/detail",
        name: "ReimburseDetail",
        component: ReimburseDetail,
      },
      {
        //  用章详情
        path: "/item/seal/detail",
        name: "SealDetail",
        component: SealDetail,
      },
      {
        //  所有申请
        path: "/apply/allApply",
        name: "AllApply",
        component: AllApply,
      },
      {
        //  所有内审单
        path: "/apply/allReimburse",
        name: "AllReimburse",
        component: AllReimburse,
      },
      {
        // 所有项目
        path: "/system/project/all",
        name: "allProject",
        component: allProject,
      },
      {
        // 所有合同
        path: "/system/contract/all",
        name: "AllContract",
        component: AllContract,
      },
      {
        // 所有项目交付申请
        path: "/system/delivery/all",
        name: "AllDelivery",
        component: AllDelivery,
      },
      {
        // 所有项目付款申请
        path: "/system/payment/all",
        name: "AllPayment",
        component: AllPayment,
      },
      {
        // 所有备用金付款申请
        path: "/system/pettyCash/all",
        name: "AllPettyCash",
        component: AllPettyCash,
      },
      {
        //  备用金申请
        path: "/item/pettyCash",
        name: "PettyCash",
        component: PettyCash,
      },
      {
        //  备用金申请详情
        path: "/item/pettyCash/detail",
        name: "PettyCashDetail",
        component: PettyCashDetail,
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/toast/login/success",
    name: "loginSuccess",
    component: loginSuccess,
  },
  {
    path: "/toast/login/fail",
    name: "loginFail",
    component: loginFail,
  },
  {
    path: "/toast/banding/success",
    name: "bandingSuccess",
    component: bandingSuccess,
  },
  {
    path: "/toast/banding/fail",
    name: "bandingFail",
    component: bandingFail,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  if (!!window.ActiveXObject || "ActiveXObject" in window) {
    next("browser");
  }
  if (to.name == "login" || to.fullPath.indexOf("toast") >= 0) {
    next();
  } else {
    let token = window.localStorage.getItem("jwt");
    if (token == undefined || token == null || token == "") {
      next("/login");
    } else {
      next();
    }
  }
});

export default router;
